import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { emojify } from "shared/modules/AsyncEmoji";
import Linkify from "react-linkify";
import unescape from "lodash/unescape";

const SanitizedText = ({
	Element,
	text,
	shouldDangerouslySetInnerHTML,
	...props
}) => {
	const domRef = useRef();
	useEffect(() => {
		if (!domRef.current) {
			return;
		}

		emojify(domRef.current);
	});

	// Live on the edge, why not.
	if (shouldDangerouslySetInnerHTML) {
		return (
			<Element
				ref={domRef}
				dangerouslySetInnerHTML={{ __html: unescape(text) }}
				{...props}
			/>
		);
	}

	// How to render the links it finds.
	const renderLink = (decoratedHref, decoratedText, key) => (
		<a key={key} target="_blank" rel="noreferrer noopener nofollow" href={decoratedHref}>
			{decoratedText}
		</a>
	);

	return (
		<Element ref={domRef} {...props}>
			<Linkify componentDecorator={renderLink}>
				{unescape(text)}
			</Linkify>
		</Element>
	);
};

SanitizedText.propTypes = {
	Element: PropTypes.string,
	text: PropTypes.string,
	shouldDangerouslySetInnerHTML: PropTypes.bool,
};

SanitizedText.defaultProps = {
	Element: "div",
	text: "",
	shouldDangerouslySetInnerHTML: false,
};

export default SanitizedText;



// WEBPACK FOOTER //
// ./src/shared/components/SanitizedText.jsx